module.exports = __webpack_public_path__ + "img/help.552c10ea.png";